import { render, staticRenderFns } from "./faturakopya.vue?vue&type=template&id=75d5fc6c&"
import script from "./faturakopya.vue?vue&type=script&lang=js&"
export * from "./faturakopya.vue?vue&type=script&lang=js&"
import style0 from "./faturakopya.vue?vue&type=style&index=0&id=75d5fc6c&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports